import { createContext, useContext, useState, useCallback } from 'react';

interface FeedbackContextType {
  isWidgetOpen: boolean;
  prefillSource: string | null;
  openWidget: (source?: string | null) => void;
  closeWidget: () => void;
}

const FeedbackContext = createContext<FeedbackContextType>({
  isWidgetOpen: false,
  prefillSource: null,
  openWidget: () => {},
  closeWidget: () => {},
});

export function FeedbackProvider({ children }: { children: React.ReactNode }) {
  const [isWidgetOpen, setIsWidgetOpen] = useState(false);
  const [prefillSource, setPrefillSource] = useState<string | null>(null);

  const openWidget = useCallback((source?: string | null) => {
    setPrefillSource(source ?? null);
    setIsWidgetOpen(true);
  }, []);

  const closeWidget = useCallback(() => {
    setIsWidgetOpen(false);
  }, []);

  return (
    <FeedbackContext.Provider value={{ isWidgetOpen, prefillSource, openWidget, closeWidget }}>
      {children}
    </FeedbackContext.Provider>
  );
}

export function useFeedbackWidget() {
  return useContext(FeedbackContext);
}
